import React from "react";
import { CheckCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import { Typography } from "antd";
import { formatSavedAgo } from "../../utils/agentAutoSaveFeedback";

const { Text } = Typography;

interface AgentAutoSaveStatusProps {
  saving?: boolean;
  lastSaved?: Date | null;
  idleText?: string;
}

export const AgentAutoSaveStatus: React.FC<AgentAutoSaveStatusProps> = ({
  saving = false,
  lastSaved = null,
  idleText = "Changes save automatically",
}) => {
  if (saving) {
    return (
      <Text type="secondary" style={{ fontSize: 12 }}>
        <LoadingOutlined style={{ marginRight: 4, color: "#1890ff" }} />
        Saving...
      </Text>
    );
  }

  if (lastSaved) {
    return (
      <Text style={{ fontSize: 12, color: "#52c41a" }}>
        <CheckCircleOutlined style={{ marginRight: 4 }} />
        Saved {formatSavedAgo(lastSaved)}
      </Text>
    );
  }

  return (
    <Text type="secondary" style={{ fontSize: 12 }}>
      {idleText}
    </Text>
  );
};
